import { render, staticRenderFns } from "./GRCMetadataManager.vue?vue&type=template&id=fcf2c258&scoped=true&"
import script from "./GRCMetadataManager.vue?vue&type=script&lang=js&"
export * from "./GRCMetadataManager.vue?vue&type=script&lang=js&"
import style0 from "./GRCMetadataManager.vue?vue&type=style&index=0&id=fcf2c258&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf2c258",
  null
  
)

export default component.exports